import { useState, useEffect } from "react";
import { ME, NAV_SECTIONS } from "../constants/portfolioData";

/**
 * Navbar
 * Fixed top nav with scroll-spy active state and mobile hamburger menu.
 * @param {function} scrollTo - scroll to a section by id
 */
const Navbar = ({ scrollTo }) => {
  const [activeNav, setActiveNav] = useState("Home");
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      for (const section of [...NAV_SECTIONS].reverse()) {
        const el = document.getElementById(section.toLowerCase());
        if (el && window.scrollY >= el.offsetTop - 150) {
          setActiveNav(section);
          break;
        }
      }
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNavClick = (section) => {
    scrollTo(section);
    setMobileOpen(false);
  };

  return (
    <>
      <style>{`
        .nav { position: fixed; top: 0; left: 0; right: 0; z-index: 200; background: #ffffffee; backdrop-filter: blur(16px); border-bottom: 1px solid var(--border); }
        .nav-inner { max-width: 1120px; margin: 0 auto; padding: 0 2rem; height: 60px; display: flex; align-items: center; justify-content: space-between; }
        .nav-logo { font-family: 'IBM Plex Mono', monospace; font-size: 0.9rem; font-weight: 600; color: var(--text); display: flex; align-items: center; gap: 0.6rem; }
        .logo-dot { width: 8px; height: 8px; background: var(--accent); border-radius: 50%; }
        .nav-links { display: flex; align-items: center; gap: 0.1rem; }
        .nl { padding: 0.4rem 0.8rem; font-family: 'IBM Plex Mono', monospace; font-size: 0.78rem; color: var(--muted); border-radius: 5px; cursor: pointer; transition: all 0.2s; border: none; background: none; }
        .nl:hover { color: var(--text); background: var(--bg3); }
        .nl.act { color: var(--accent2); }
        .nav-cta { margin-left: 1rem; padding: 0.45rem 1rem; background: var(--accent); color: #fff; border-radius: 6px; font-family: 'IBM Plex Mono', monospace; font-size: 0.78rem; font-weight: 500; cursor: pointer; border: none; transition: all 0.2s; text-decoration: none; }
        .nav-cta:hover { background: #2563eb; transform: translateY(-1px); }
        .hamburger { display: none; background: none; border: 1px solid var(--border2); border-radius: 5px; padding: 0.35rem 0.55rem; cursor: pointer; color: var(--text); font-size: 1rem; }
        .mob-nav { display: none; position: fixed; inset: 0; background: #ffffff; z-index: 199; padding: 5rem 2rem 2rem; flex-direction: column; gap: 1.5rem; border-right: 1px solid var(--border); }
        .mob-nav.open { display: flex; }
        .mnl { font-family: 'IBM Plex Mono', monospace; font-size: 1.1rem; color: var(--text); cursor: pointer; padding-bottom: 1rem; border-bottom: 1px solid var(--border); }
      `}</style>

      <nav className="nav">
        <div className="nav-inner">
          <div className="nav-logo">
            <div className="logo-dot" />
            {ME.name.split(" ")[0].toLowerCase()}.dev
          </div>
          <div className="nav-links">
            {NAV_SECTIONS.map((s) => (
              <button
                key={s}
                className={`nl ${activeNav === s ? "act" : ""}`}
                onClick={() => handleNavClick(s)}
              >
                {s}
              </button>
            ))}
            <a href={ME.resumeUrl} className="nav-cta" target="_blank" rel="noreferrer">
              Resume ↓
            </a>
          </div>
          <button className="hamburger" onClick={() => setMobileOpen(!mobileOpen)}>
            ☰
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      <div className={`mob-nav ${mobileOpen ? "open" : ""}`}>
        {NAV_SECTIONS.map((s) => (
          <div key={s} className="mnl" onClick={() => handleNavClick(s)}>
            {s}
          </div>
        ))}
        <a href={ME.resumeUrl} className="btn-p" style={{ marginTop: "1rem" }}>
          Download Resume ↓
        </a>
      </div>
    </>
  );
};

export default Navbar;